"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UI = /** @class */ (function () {
    function UI() {
    }
    return UI;
}());
exports.UI = UI;



//////////////////
// WEBPACK FOOTER
// ./src/export_ui.ts
// module id = 332
// module chunks = 0